/* eslint-disable import/prefer-default-export */
export const getTotal = (service, group) => {
  const array = service
    ?.filter((item) => item.group === group)
    .map((item) => ({ total: item.num_services * parseInt(item.price_per_month, 10) || 0 }));
  const sum = array.reduce((accumulator, currentValue) => accumulator + currentValue.total, 0);
  return sum;
};
